export default {
  loading: true,
  company: {},
  bankAccount: {},
  companies: {
    values: [],
    total: 0,
    totalOfPages: 0
  },
  invoice: {},
  invoices: {
    values: [],
    total: 0,
    totalOfPages: 0
  },
  invoiceOrderServices: [],
  billings: [],
  customer: {},
  customers: {
    values: [],
    total: 0,
    totalOfPages: 0
  },
  budget: {
    bulkService: [],
    bulkMaterial: [],
    bulkExpense: [],
    commissionPercentage: 0.15,
    material: { percentage: 0.0 },
    refund: { percentage: 0.0 },
    serviceValueTotal: 0,
    serviceValueDiscount: 0,
    materialValueTotal: 0,
    materialValueDiscount: 0,
    protocol: "",
    descriptionScope: "",
    owner: {},
    hirer: "",
    provider: "",
    executionDeadline: "",
    details: "",
    paymentMethod: "",
    id: ""
  },
  budgets: {
    values: [],
    total: 0,
    totalOfPages: 0
  },
  budgetProposal: {},
  budgetProposals: {
    values: [],
    total: 0,
    totalOfPages: 0
  },
  address: {},
  addresses: {
    values: [],
    total: 0,
    totalOfPages: 0
  },
  contact: {},
  contacts: {
    values: [],
    total: 0,
    totalOfPages: 0
  },
  service: {},
  services: {
    values: [],
    total: 0,
    totalOfPages: 0
  },
  provider: {},
  providers: {
    values: [],
    total: 0,
    totalOfPages: 0
  },
  agent: {},
  agents: {
    values: [],
    total: 0,
    totalOfPages: 0
  },
  serviceOrder: {
    commissionPercentage: 0.15,
    material: { percentage: 0.0 },
    refund: { percentage: 0.0 },
    price: 0,
    valueMaterial: 0,
    valueRefund: 0
  },
  serviceOrders: {
    values: [],
    total: 0,
    totalOfPages: 0
  },
  employee: {},
  employees: {
    values: [],
    total: 0,
    totalOfPages: 0
  },
  quiz: {
    id: "",
    companyId: 0,
    formName: "",
    listCard: [
      {
        itemTitle: "",
        requiredField: false,
        inputs: [
          {
            type: "",
            label: "",
            value: ""
          }
        ]
      }
    ],
    listService: []
  },
  questionnaires: {
    values: [],
    total: 0,
    totalOfPages: 0
  },
  contractor: [],
  searchContractor: [],
  searchCustomer: [],
  searchAddress: [],
  tontonSearchAddress: [],
  searchContact: [],
  searchService: [],
  account: {},
  checkEmail: {},
  dashboards: [],
  report: {},
  reports: {
    values: [],
    total: 0,
    totalOfPages: 0
  },
  file: {},
  files: [],
  receipts: [],
  providerReceipts: [],
  providersSelected: [],
  agentsSelected: [],
  filesOrderService: [],
  filesTecSubmit: [],
  saveEmail: "",
  notifications: [],
  providerHirers: []
};



// WEBPACK FOOTER //
// ./src/redux/initial.state.js